import React from "react";
import { Link } from "react-router-dom";

// layout
import { Header } from "../../../layout/Header";

// icons
import { ChevronLeft, House } from "lucide-react";

const ListHeader = () => {
  return (
    <Header
      className="app-header fixed-top"
      size="md"
      start={
        <div className="w-25 d-flex flex-column align-items-center">
          <Link key="/toat" to="/toat" aria-label="Tale List">
            <House size={32} />
            {/* <span> Home</span> */}
          </Link>
        </div>
      }
      center={
        <div className="w-50 d-flex flex-column align-items-center">
          <div className="tale-title text-center">
            <h4>My Tales</h4>
          </div>
        </div>
      }
      end={<div className="w-25 d-flex flex-column align-items-center"></div>}
    />
  );
};

export default ListHeader;
